import { useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';

let lastLocation = null;
let isUpdated = 1;

export function usePreviousLocationTracker() {
  const location = useLocation();
  const previousRef = useRef(null);

  useEffect(() => {
    // Save the previous location BEFORE updating the ref
    if (isUpdated === 1) {
        lastLocation = previousRef.current;
        isUpdated = 0;
    } else {
    // Update ref AFTER saving
    previousRef.current = location;
    isUpdated = 1;
    }
  }, [location]);
}

export function getLastLocation() {
  return lastLocation;
}